<app-nav-menu></app-nav-menu>
<div class="container app-content">
<app-products></app-products>
</div>
<div class="footer mt-auto">
    <div
    class="navbar sticky-bottom navbar-expand-md navbar-dark bg-brand-dk-blue "
  >
    <div class="collapse navbar-collapse me-auto text-center">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" href="https://surescripts.com/terms-of-use" target="_blank" rel="noreferrer noopener">Terms and Conditions</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://surescripts.com/our-story/privacy" target="_blank" rel="noreferrer noopener">Privacy Policy</a>
        </li>

      </ul>
    </div>
    <img src="../assets/img/logo-white.svg" class="" style="max-width: 100px" />
  </div>
</div>
